"use client";
import {
  slider_default
} from "./chunk-PQTYAHT6.mjs";
import "./chunk-47QEQS7H.mjs";
import "./chunk-4TRUIEJG.mjs";
import {
  useSlider
} from "./chunk-SUUQJ6MB.mjs";
export {
  slider_default as Slider,
  useSlider
};
